import { render, staticRenderFns } from "./ServiceProps.vue?vue&type=template&id=28806890&scoped=true&"
import script from "./ServiceProps.vue?vue&type=script&lang=js&"
export * from "./ServiceProps.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProps.vue?vue&type=style&index=0&id=28806890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28806890",
  null
  
)

export default component.exports